export const SPACE_MODES = ["public", "private", "personal"] as const;
export type SpaceMode = (typeof SPACE_MODES)[number];

export const USER_ASSIGNABLE_SPACE_MODES = ["private"] as const;
